import React, { useEffect, useState } from 'react';
import { Button, TextField, FormControl, InputLabel, MenuItem, Select, Dialog, DialogActions, DialogContent } from '@mui/material';
import { DatePicker, LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import './../Shipments.css';
import CloseIcon from '@mui/icons-material/Close';
import CheckRoundedIcon from '@mui/icons-material/CheckRounded';
import { getCompaniesList } from '../../../Helper/userActivityApi';

const FilterModal = ({
    handleSearch,
    startDate,
    endDate,
    sUser,
    handleStartDateChange,
    handleEndDateChange,
    table,
    handleTableChange,
    isFilterPopupOpen,
    closeFilterModal,
    users
}) => {

    const [selectedUser, setSelectedUser] = useState('all'); // Set default to 'all'
    const [customers, setCustomers] = useState([]);


    useEffect(() => {
        console.log("Filter modal users", users);
        if (sUser === null) {
            setSelectedUser('all');
        }
        const fetchCompaniesList = async () => {
            try {
                const [customersResponse] = await Promise.all([
                    getCompaniesList(),
                ]);
                console.log(customersResponse);
                setCustomers([...(customersResponse.data.body || [])]);
            } catch (error) {
                console.error('Error fetching dashboard data:', error);
                setCustomers([]);
            }
        }
        fetchCompaniesList();
    }, [sUser]);

    const handleUserChange = (event) => {
        setSelectedUser(event.target.value);
    };

    const handleCustomerChange = (event) => {
        console.log(event);
        localStorage.setItem('companyName', event.target.value);
        const selectedCustomer = customers.find(customer => customer.company_value === event.target.value);
        localStorage.setItem('selectedCompanyUuid', selectedCustomer.company_uuid);
    };

    const handleSearchClick = () => {
        handleSearch(selectedUser, users.find(user => { return user.user_id === selectedUser }), startDate, endDate);
        closeFilterModal();
    };

    return (
        <Dialog open={isFilterPopupOpen} onClose={closeFilterModal} maxWidth="sm" fullWidth>
            <DialogContent>
                <div className='row'>
                    <div className='col-12 filter-header'>
                        <span className='shipment-header'>
                            Filters
                        </span>
                        <CloseIcon onClick={closeFilterModal} className='fl-r pointer'></CloseIcon>
                    </div>
                    {/* <div className='col-lg-6'>
                        <FormControl className="mt-3 ml-3 w-80">
                            <InputLabel>Document Type</InputLabel>
                            <Select
                                className='h-2em'
                                value={table}
                                label="Document Type"
                                onChange={handleTableChange}
                            >
                                <MenuItem value={'invoices'}>Invoices</MenuItem>
                                <MenuItem value={'rateConfirmations'}>Rate Confirmations</MenuItem>
                                <MenuItem value={'proofOfDelivery'}>Proof of Deliveries</MenuItem>
                            </Select>
                        </FormControl>
                    </div> */}
                    <div className='col-lg-6'>
                        <FormControl className="mt-3 ml-3 w-80">
                            <InputLabel>User</InputLabel>
                            <Select
                                className='h-2em'
                                value={selectedUser}
                                label="User"
                                onChange={handleUserChange}
                            >
                                <MenuItem value='all'>All</MenuItem>
                                {users && users.map((user) => (
                                    <MenuItem key={user.user_id} value={user.user_id}>
                                        {user.first_name + " " + user.last_name}
                                    </MenuItem>
                                ))}
                            </Select>
                        </FormControl>
                    </div>
                    <div className='col-lg-6'>
                        {localStorage.getItem('masterCompanyName') === 'bizcloudExperts' && (
                            <FormControl className="mt-3 ml-3 w-80">
                                <InputLabel id="customer-list-label">Company</InputLabel>
                                <Select
                                    labelId="customer-list-label"
                                    id="customer-list"
                                    value={localStorage.getItem('companyName')}
                                    onChange={handleCustomerChange}
                                    label="Customers"
                                    style={{ height: '2em' }}
                                >
                                    {customers.map((customer) => (
                                        <MenuItem key={customer.company_uuid} value={customer.company_value}>
                                            {customer.company_label || customer.company_value}
                                        </MenuItem>
                                    ))}
                                </Select>
                            </FormControl>
                        )}
                    </div>
                    <div className='col-lg-6'>
                        <LocalizationProvider dateAdapter={AdapterDayjs}>
                            <DatePicker
                                label="Start Date"
                                value={startDate}
                                className="mt-3 ml-3 w-80"
                                onChange={handleStartDateChange}
                                renderInput={(params) => <TextField {...params} />}
                            />
                        </LocalizationProvider>
                    </div>
                    <div className='col-lg-6'>
                        <LocalizationProvider dateAdapter={AdapterDayjs}>
                            <DatePicker
                                label="End Date"
                                value={endDate}
                                className="mt-3 ml-3 w-80"
                                onChange={handleEndDateChange}
                                renderInput={(params) => <TextField {...params} />}
                            />
                        </LocalizationProvider>
                    </div>
                </div>
            </DialogContent>
            <DialogActions className='justify-center'>
                <Button onClick={handleSearchClick} variant="contained" className='theme-bg'>
                    <CheckRoundedIcon />
                    <span className='ml-3 text-trans-none'>Apply</span>
                </Button>
            </DialogActions>
        </Dialog >
    );
};

export default FilterModal;
